import { render, staticRenderFns } from "./ShowGeneralTab.vue?vue&type=template&id=da2602ea&scoped=true"
import script from "./ShowGeneralTab.vue?vue&type=script&lang=js"
export * from "./ShowGeneralTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2602ea",
  null
  
)

export default component.exports